import React from 'react'

const AdvertiseWidget = () => {
  return (
    <div className='w-full xs:min-w-[240px] flex flex-col p-4 bg-white dark:bg-gray-900 rounded-md gap-1'>
        <div className='flex justify-between flex-wrap'>
            <h3 className='text-xs font-semibold text-gray-600 dark:text-gray-200'>Sponsored</h3>
            <h3 className='text-xs text-gray-400'>Create Ad</h3>
        </div>
        <div >
            <img className='rounded-md h-[150px] object-cover w-full' src="https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80" alt="" />
        </div>
        <div className='flex items-center justify-between flex-wrap'>
            <h2 className='text-gray-600 font-medium text-xs dark:text-gray-200'>Cosmetics</h2>
            <h2 className='text-gray-400 text-xs'>cosmetics.com</h2>
        </div>
        <div>
            <p className='text-xs text-gray-400'>Your way to beautiful and unmatchable beauty, which also takes tale of your skin with our healthy products </p>
        </div>
    </div>
  )
}

export default AdvertiseWidget